import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledDatePicker from 'src/shared/components/form/controlledDatePicker';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

export const CustomerSettingsCustInformation = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography mb={2} sx={{ fontWeight: 500, color: 'text.secondary' }}>
        {t('customer:detailPage.customerInformation')}
      </Typography>
      <Box px={1}>
        <GridWrapper>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='lastName' required label={t('customer:detailPage.name')} disabled />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledDatePicker name='admDate' required label={t('customer:detailPage.registerDate')} disabled />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='coAddress' label={t('customer:detailPage.contactPerson')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='country' label={t('customer:detailPage.country')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='address' label={t('customer:detailPage.address')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='addressOther' label={t('customer:detailPage.addressOther')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='postNr' label={t('customer:detailPage.zipCode')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='postAddress' label={t('customer:detailPage.postalAddress')} />
          </Grid>

          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='phone' label={t('customer:detailPage.phone')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='phoneOther' label={t('customer:detailPage.phoneOther')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='email' label={t('customer:detailPage.email')} />
          </Grid>
        </GridWrapper>
      </Box>
    </>
  );
};
